import { useSession } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import { type FC, useState } from 'react'

import { PostAdButton } from '@/components/shared/global-header/styled'
import { RouteLink } from '@/components/shared/route-link'
import { type Route } from '@/constants/routes'
import { isUserAuthenticated } from '@/features/auth/constants/user'
import { useSignin } from '@/features/auth/hooks/useSignin'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'

export type PostAdCTAProps = {
  namespace: string
  postAdGAEventLabel: string
  testId: string
  translationContentKey: string
  callbackUrl: string
  route: Route
  /**
   * Enables styled component overrides, overrides are lost if this prop is removed.
   */
  className?: string
}

export const PostAdCTA: FC<PostAdCTAProps> = ({
  namespace,
  postAdGAEventLabel,
  testId,
  translationContentKey,
  callbackUrl,
  route,
  className,
}) => {
  const [goToSignIn, setGoToSignIn] = useState(false)

  const { status } = useSession()
  const { t } = useTranslation(namespace)

  const trackPostAdBegin = () => {
    trackEvent({ action: GA_EVENT.PostAdBegin, label: postAdGAEventLabel })
  }

  const handleSignInClick = () => {
    /**TODO: it should redirect to postAd link after login is completed */
    setGoToSignIn(true)
  }

  useSignin({ callbackUrl, goToSignIn })

  /**
   * If user is not authenticated and path is supposed to come from webapp
   * Then POST_AD should be a button to hosted CIS
   */
  if (!isUserAuthenticated(status)) {
    return (
      <PostAdButton
        data-testid={testId}
        onClick={handleSignInClick}
        size="small"
        className={className}
      >
        {t(translationContentKey)}
      </PostAdButton>
    )
  }

  return (
    <RouteLink route={route} prefetch={false}>
      <PostAdButton
        data-testid={testId}
        forwardedAs="a"
        onClick={trackPostAdBegin}
        rel="nofollow"
        size="small"
        className={className}
      >
        {t(translationContentKey)}
      </PostAdButton>
    </RouteLink>
  )
}
